import React, { useState } from "react";
import Head from "next/head";
import FeaturedBlogs from "../../../components/VLSI/featuredBlogs";
import Menu from "../../../components/VLSI/menu";
import MobileMenu from "../../../components/VLSI/mobileMenu";
import Modal from "../../../components/VLSI/modal";
import { redirectTo500 } from "../../../utils/utility";
import ghost from "../../../utils/ghost";
import Footer from "../../../components/VLSI/footer";
import MobileFooter from "../../../components/VLSI/mobileFooter";

export async function getStaticProps(context) {
  const featuredData = await ghost({
    filter: "tags:blog" + "+tags:vlsi",
    pagination: { limit: 3 },
  });
  const listPagedData = await ghost({
    filter: "tags:blog" + "+featured:false",
    pagination: { limit: "all" },
  });

  if (!featuredData || !listPagedData) {
    return redirectTo500();
  }
  return {
    props: {
      featured: featuredData,
      listData: listPagedData,
    },
    revalidate: 3600,
  };
}

const Firmware = (props) => {
  // modal state
  const [showModal, setShowModal] = useState(false);
  const handleOnClose = () => setShowModal(false);
  return (
    <div>
      <Head>
        <title>Firmware | Harware Solution in Bangladesh</title>
        <meta
          name="description"
          content="DSi blog space covers the latest technologies and industry trends in eloquent articles penned by our seasoned tech enthusiasts."
        />
      </Head>
      <div className="negative-margin sticky top-0 z-50">
        <header className="hidden lg:block w-full bg-black sticky top-0 z-50">
          <Menu />
        </header>
        <header className="block lg:hidden w-full bg-black sticky top-0 z-50">
          <MobileMenu />
        </header>
      </div>
      {/* page contents */}
      {/* hero section */}
      <section className="bg-[url(/images/VLSI/firmware/firmware_hero_background_img.png)] bg-no-repeat bg-cover backdrop-brightness-0  ">
        <div className="flex justify-between  items-center max-w-screen-xl mx-auto p-7 lg:py-24">
          <div className=" lg:basis-3/5 flex flex-col gap-3 sm:gap-6 ">
            <div className=" font-bold sm:font-extrabold text-2xl sm:text-4xl lg:text-6xl text-white ">
              Embedded and Firmware
            </div>
            <div className="lg:text-xl text-white lg:leading-relaxed">
              Welcome! Explore our work as we bridge the gap between hardware
              and software, providing innovative solutions and simulations that
              drive technological advancements. Here, we delve into the
              fascinating world of digital systems, offering insights,
              expertise, and solutions in these crucial areas of computer
              engineering. Join us on this journey through the intricate realms
              of firmware development, and transaction-level modeling, where we
              bring concepts to life and push the boundaries of what's possible
              in the digital landscape.
            </div>
            <div className=" mt-2 flex gap-4">
              <button
                onClick={() => {
                  setShowModal(true);
                }}
                className=" inline-flex items-center gap-2 px-5 py-3 bg-[#1A56DB] hover:bg-blue-800 text-white  "
              >
                Contact Us <img src="/images/VLSI/ic/arrow-right.svg" />
              </button>
              <a
                href="#second_section_FW"
                className=" inline-flex px-5 py-3 bg-gray-50 hover:bg-gray-100  border border-gray-200 "
              >
                Learn More
              </a>
            </div>
          </div>
          {/* <div className="hidden lg:block">
            <img
              src="/images/VLSI/firmware/firmware_hero_section_image.png"
              className=" object-contain"
            />
          </div> */}
        </div>
      </section>
      {/* modal */}
      <Modal visible={showModal} onClose={handleOnClose} />
      {/* modal ENDS */}
      {/* hero section ENDS */}
      {/* 2nd section */}
      <section className="bg-gray-100" id="second_section_FW">
        <div className=" max-w-screen-xl mx-auto p-7 lg:py-24 lg:px-[30px]">
          <div className="flex flex-col gap-10 lg:gap-20">
            {/* 1 */}
            <div className="flex flex-col-reverse lg:flex-row justify-between items-center gap-6 sm:gap-12 lg:gap-24">
              <div className="lg:basis-1/2">
                <img
                  src="/images/VLSI/firmware/embedded_application_development.png"
                  className="max-w-full"
                />
              </div>
              <div className="lg:basis-1/2">
                <p className="text-2xl lg:text-4xl font-bold">
                  Embedded Application Development
                </p>
                <p className="text-gray-500 mt-3">
                  We have expertise in creating solutions using
                  microcontrollers(ESP32) that utilize multiple cores and
                  multi-threading capabilities through FreeRTOS. We provide the
                  best performance using parallel processing and efficient
                  handling of tasks. To conserve power, we excel in utilizing
                  modem sleep mode when not actively processing data. We also
                  master at using interrupts to activate the modules and trigger
                  the connected devices ensuring a responsive and
                  power-efficient system.
                </p>
              </div>
            </div>
            {/* 2 */}
            <div className="flex flex-col-reverse lg:flex-row-reverse justify-between items-center gap-6 sm:gap-12 lg:gap-24">
              <div className="lg:basis-1/2">
                <img
                  src="/images/VLSI/firmware/transaction_level_modeling.png"
                  className="max-w-full"
                />
              </div>
              <div className="lg:basis-1/2">
                <p className="text-2xl lg:text-4xl font-bold">
                  Transaction-Level Modeling (TLM)
                </p>
                <p className="text-gray-500 mt-3">
                  We excel in cutting-edge System-on-Chip (SoC) designs,
                  leveraging advanced SystemC techniques. Our commitment to
                  excellence is evident in our use of Transaction-Level Modeling
                  (TLM) and versatile multithreading methods, including clocked
                  and non-clocked designs. Our services cover multicore
                  execution units, memory systems (including BootROM and DDR),
                  cache optimization, interrupt handling (integrating with CLINT
                  and PLICs), and a wide range of peripherals (UART, I2C, SPI,
                  DMA, ADC, DAC, GPIO, and Datalogger). We prioritize
                  reliability with watchdog timers and enable seamless
                  communication through buses.
                </p>
              </div>
            </div>
            {/* 3 */}
            <div className="flex flex-col-reverse lg:flex-row justify-between items-center gap-6 sm:gap-12 lg:gap-24">
              <div className="lg:basis-1/2">
                <img
                  src="/images/VLSI/firmware/rtl_software_simulator.png"
                  className="max-w-full"
                />
              </div>
              <div className="lg:basis-1/2">
                <p className="text-2xl lg:text-4xl font-bold">
                  RTL Software Simulator
                </p>
                <p className="text-gray-500 mt-3">
                  At  DSI, we specialize in RTL model creation. With a strong
                  foundation in C++ and OOP, we design and develop advanced
                  RISC-V RTL simulators. Our expertise spans RISC-V ISA base
                  extensions, vector extensions , supporting complex operations
                  like matrix multiplication. We provide comprehensive support
                  for scalar and vector modes, privileged  and supervisor modes,
                  kernel development and multi-level caching.
                </p>
              </div>
            </div>
            {/* 4 */}
            <div className="flex flex-col-reverse lg:flex-row-reverse justify-between items-center gap-6 sm:gap-12 lg:gap-24">
              <div className="lg:basis-1/2">
                <img
                  src="/images/VLSI/firmware/testing_and_automation.png"
                  className="max-w-full"
                />
              </div>
              <div className="lg:basis-1/2">
                <p className="text-2xl lg:text-4xl font-bold">
                  Testing and Automation
                </p>
                <p className="text-gray-500 mt-3">
                  We are adept at planning and developing automated test suites
                  for the firmware system in Python, rooted in OOP concepts.
                  These versatile suites such as FPGA and RTL targets and offer
                  user-level customization. Our streamlined approach includes
                  CI/CD pipelines for automated testing on commits and merge
                  requests, accompanied by periodic regression testing for
                  continuous validation.
                </p>
              </div>
            </div>
            {/* 5 */}
            <div className="flex flex-col-reverse lg:flex-row justify-between items-center gap-6 sm:gap-12 lg:gap-24">
              <div className="lg:basis-1/2">
                <img
                  src="/images/VLSI/firmware/testing_framework_proficiency.png"
                  className="max-w-full"
                />
              </div>
              <div className="lg:basis-1/2">
                <p className="text-2xl lg:text-4xl font-bold">
                  Testing Framework Proficiency
                </p>
                <p className="text-gray-500 mt-3">
                  We possess practical expertise in utilizing open-source RISC-V
                  processor verification frameworks. Moreover, we have also
                  worked to develop a custom testing framework for the RISC-V
                  processor. Some of the testing frameworks used by us are:
                  <ul className=" list-inside list-disc mt-2">
                    <li>RISCV-DV</li>
                    <li>RISCOF</li>
                    <li>RISC-V Vector Tests</li>
                    <li>RISC-V Torture Test </li>
                    <li>Riscv-tests</li>
                  </ul>
                </p>
              </div>
            </div>
          </div>

          {/* tools list ENDS */}
        </div>
      </section>
      {/* 2nd section ENDS */}

      {/* 3rd section Technologies and Tools */}
      <section className="bg-gray-50">
        <div className=" max-w-screen-xl mx-auto p-7 lg:py-24 lg:px-[30px]">
          <div className="text-center text-2xl sm:text-4xl text-gray-900 font-bold mb-3 sm:mb-6 lg:mb-12 ">
            Technologies and Tools
            <p className="mt-2 sm:mt-4 text-base sm:text-xl lg:leading-relaxed text-gray-500 font-normal">
              Cutting-edge Technologies and Powerful Tools for Innovative
              Solutions and Efficient Development.
            </p>
          </div>
          {/* tool list */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-8 place-items-center">
            <div>
              <img src="/images/VLSI/firmware/c++.png" />
            </div>
            <div>
              <img src="/images/VLSI/firmware/rtos.png" />
            </div>
            <div>
              <img src="/images/VLSI/firmware/python.png" />
            </div>
            <div>
              <img src="/images/VLSI/firmware/riscv.png" />
            </div>
            <div>
              <img src="/images/VLSI/firmware/systemc.png" />
            </div>
            <div>
              <img src="/images/VLSI/firmware/bare_metal_c.png" />
            </div>
            <div>
              <img src="/images/VLSI/firmware/esp32.png" />
            </div>
            <div>
              <img src="/images/VLSI/firmware/gdb_archer.png" />
            </div>
          </div>
          {/* tool list ENDS */}
        </div>
      </section>
      {/* 3rd section Technologies and Tools ENDS */}
      {/* page contents ENDS */}
      {/* featured */}
      <div className="bg-gray-100 w-full py-10 sm:py-20">
        <div className="grid mid-home-column">
          <div className="pb-12 items-center flex flex-col">
            <h2 className="text-black font-headline items-center break-words text-center font-extrabold text-3xl md:text-4xl mb-1">
              Read what we wrote
            </h2>
            <p className="text-center flex font-headline items-center text-base md:text-xl leading-8 text-gray-600">
              Get front-row industry insights
            </p>
          </div>
          <div className="flex justify-center mx-5">
            <FeaturedBlogs
              how={props.featured.posts}
              path="/blogs/"
              title="VIEW DETAILS"
            />
          </div>
        </div>
      </div>

      {/* {showModal && <Modal />} */}
      <div className="hidden md:block md:footer-div absolute z-50 bg-black md:py-24 w-full px-10 xl:px-32">
        <Footer />
      </div>
      <div className="block md:hidden absolute z-50 bg-black py-10 w-full px-7">
        <MobileFooter />
      </div>
    </div>
  );
};

export default Firmware;
